import SettingsColleagues from './SettingsColleagues'

export default SettingsColleagues
